export interface IData {
    key: string;
    form: string[];
    sound: string[];
    define?: string;
}

export interface IDict {
  name: string;
  description: string;
  content: Record<string, IData[]>;
  edit: "disallow" | "allow";
}


export const busu: IDict = {
  name: "부수",
  description: "강희자전 방식의 부수 214자를 모아두었습니다.",
  edit: "disallow",
  content: {
    "1획": [
      { key: "1획-1", form: ["一"], sound: ["한 일"] },
  
      { key: "1획-2", form: ["丨"], sound: ["뚫을 곤"] },
  
      { key: "1획-3", form: ["丶"], sound: ["점주"] },
  
      { key: "1획-4", form: ["丿"], sound: ["삐침 별"] },
  
      { key: "1획-5", form: ["乙", "⺃"], sound: ["새 을"] },
  
      { key: "1획-6", form: ["亅"], sound: ["갈고리 궐"] },
    ],
    "2획": [
      { key: "2획-1", form: ["二"], sound: ["두 이"] },
  
      { key: "2획-2", form: ["亠"], sound: ["돼지해머리 두"], define: "돼지해 머리: 돼지 해(亥) 자의 머리." },
  
      { key: "2획-3", form: ["人", "亻"], sound: ["사람 인", "사람인변"] },
  
      { key: "2획-4", form: ["儿"], sound: ["어진사람 인"] },
  
      { key: "2획-5", form: ["⼊"], sound: ["들 입"] },
  
      { key: "2획-6", form: ["⼋"], sound: ["여덟 팔"] },
  
      { key: "2획-7", form: ["⼌"], sound: ["멀 경"] },
  
      { key: "2획-8", form: ["⼍"], sound: ["덮을 멱", "민갓머리"], define: "민갓머리: 갓머리(宀)에서 위에 점이 없다는 뜻." },
  
      { key: "2획-9", form: ["⼎"], sound: ["얼음 빙", "이수변"], define: "이수 변: 물 수(水)는 셋인데 두 개라는 뜻." },
  
      { key: "2획-10", form: ["⼏"], sound: ["안석 궤"], define: "안석: 앉는 의자" },
  
      { key: "2획-11", form: ["⼐"], sound: ["입벌릴 감", "위튼입구"], define: "위튼입구: 입 구(口)에서 위가 터있다는 뜻." },
  
      { key: "2획-12", form: ["⼑", "刂"], sound: ["칼 도", "선칼도방"] },
  
      { key: "2획-13", form: ["力"], sound: ["힘 력"] },
  
      { key: "2획-14", form: ["勹"], sound: ["쌀 포"] },
  
      { key: "2획-15", form: ["⼔"], sound: ["비수 비", "술 비"] },
  
      { key: "2획-16", form: ["⼕"], sound: ["상자 방", "튼입구"], define: "튼입구: 입 구(口)에서 옆이 터있다는 것." },
  
      { key: "2획-17", form: ["匸"], sound: ["감출 혜"] },
  
      { key: "2획-18", form: ["⼗"], sound: ["열 십"] },
  
      { key: "2획-19", form: ["⼘"], sound: ["점 복"] },
  
      { key: "2획-20", form: ["⼙", "㔾"], sound: ["병부 절"], define: "병부: 자루가 긴 굽은 칼." },
  
      { key: "2획-21", form: ["⼚"], sound: ["언덕 한", "민엄호"], define: "민엄호(밑): 엄호(广)에서 위에 점이 없다는 말." },
  
      { key: "2획-22", form: ["⼛"], sound: ["사사로울 사", "마늘모"], define: "마늘모: 삼각 모양의 옛 말." },
  
      { key: "2획-23", form: ["⼜"], sound: ["또 우"] },
    ],
    "3획": [
      { key: "3획-1", form: ["⼝"], sound: ["입 구"] },
  
      { key: "3획-2", form: ["⼞"], sound: ["에울 위", "큰입구몸"] },
  
      { key: "3획-3", form: ["⼟"], sound: ["흙 토"] },
  
      { key: "3획-4", form: ["⼠"], sound: ["선비 사"] },
  
      { key: "3획-5", form: ["⼡"], sound: ["뒤져올 치"], define: "뒤져올(뒤쳐올): 뒤에 처져서 온다는 말." },
  
      { key: "3획-6", form: ["⼢"], sound: ["천천히걸을 쇠"], define: "뚜벅뚜벅 걷는 소의 발." },
  
      { key: "3획-7", form: ["⼣"], sound: ["저녁 석"] },
  
      { key: "3획-8", form: ["⼤"], sound: ["큰 대"] },
  
      { key: "3획-9", form: ["⼥"], sound: ["계집 녀"] },
  
      { key: "3획-10", form: ["⼦"], sound: ["아들 자"] },
  
      { key: "3획-11", form: ["⼧"], sound: ["집 면", "갓머리"] },
  
      { key: "3획-12", form: ["⼨"], sound: ["마디 촌"] },
  
      { key: "3획-13", form: ["⼩"], sound: ["작을 소"] },
  
      { key: "3획-14", form: ["尢", "兀", "尣"], sound: ["절름발이 왕"] },
  
      { key: "3획-15", form: ["⼫"], sound: ["주검 시"] },
  
      { key: "3획-16", form: ["屮"], sound: ["싹날 철"] },
  
      { key: "3획-17", form: ["⼭"], sound: ["뫼 산"], define: "뫼(메): 산의 옛 말." },
  
      { key: "3획-18", form: ["川", "⼮"], sound: ["내 천", "개미허리"] },
  
      { key: "3획-19", form: ["⼯"], sound: ["장인 공"] },
  
      { key: "3획-20", form: ["⼰"], sound: ["몸 기"] },
  
      { key: "3획-21", form: ["⼱"], sound: ["수건 건"] },
  
      { key: "3획-22", form: ["⼲"], sound: ["방패 간"] },
  
      { key: "3획-23", form: ["⼳"], sound: ["작을 요"] },
  
      { key: "3획-24", form: ["⼴"], sound: ["집 엄", "엄호"], define: "엄호: 지붕이 한쪽으로 늘어뜨려진 것." },
  
      { key: "3획-25", form: ["⼵"], sound: ["끌 인", "길게걸을 인", "민책받침"], define: "민책받침: 책받침(辶)에서 위에 점이 없다는 뜻." },
  
      { key: "3획-26", form: ["⼶"], sound: ["바칠 공", "밑스물입"], define: "밑스물입(스물입발): 십(十)이 둘로 스물이며 발이 있다는 뜻." },
  
      { key: "3획-27", form: ["⼷"], sound: ["주살 익"], define: "주살: 활쏘기 연습할 때 화살에 줄을 매달고 쏘는데 그 줄." },
  
      { key: "3획-28", form: ["⼸"], sound: ["활 궁"] },
  
      { key: "3획-29", form: ["⼹", "彑"], sound: ["돼지머리 계", "튼가로왈"], define: "튼가로왈: 가로 왈(曰)에서 한 쪽이 텄다는 말." },
  
      { key: "3획-30", form: ["⼺"], sound: ["터럭 삼", "삐친석삼"] },
  
      { key: "3획-31", form: ["⼻"], sound: ["자축거릴 척", "두인변"], define: "두인변: 亻변에서 또 하나의 점이 있다는 말." },
    ],
    "4획": [
      { key: "4획-1", form: ["⼼", "忄", "㣺"], sound: ["마음 심", "심방변", "밑마음심"] },
  
      { key: "4획-2", form: ["⼽"], sound: ["창 과"] },
  
      { key: "4획-3", form: ["⼾"], sound: ["지게 호"], define: "지게: 외짝 문이 있는 안방을 지게라 함." },
  
      { key: "4획-4", form: ["⼿", "扌"], sound: ["손 수", "손수변", "재방변"] },
  
      { key: "4획-5", form: ["⽀"], sound: ["가를 지", "지탱할 지"] },
  
      { key: "4획-6", form: ["⽁", "攵"], sound: ["칠 복", "등글월문"], define: "등글: 좋거나 감탄하며 작게 무릎을 치는 것." },
  
      { key: "4획-7", form: ["⽂"], sound: ["무늬 문", "글월 문"], define: "글월: 옛날에는 글을 소중히 생각하여 글월이라 했음." },
  
      { key: "4획-8", form: ["⽃"], sound: ["말 두"] },
  
      { key: "4획-9", form: ["⽄"], sound: ["도끼 근", "날근방"], define: "날: 무게를 다는 저울의 옛 말." },
  
      { key: "4획-10", form: ["⽅"], sound: ["모 방"] },
  
      { key: "4획-11", form: ["⽆"], sound: ["없을 무", "이미기방"] },
  
      { key: "4획-12", form: ["⽇"], sound: ["날 일"] },
  
      { key: "4획-13", form: ["⽈"], sound: ["가로 왈"] },
  
      { key: "4획-14", form: ["⽉"], sound: ["달 월"] },
  
      { key: "4획-15", form: ["⽊"], sound: ["나무 목"] },
  
      { key: "4획-16", form: ["⽋"], sound: ["하품 흠"] },
  
      { key: "4획-17", form: ["⽌"], sound: ["그칠 지"] },
  
      { key: "4획-18", form: ["⽍", "歺"], sound: ["부서진뼈 알", "죽을사변"] },
  
      { key: "4획-19", form: ["⽎"], sound: ["창 수", "갖은등글월문"], define: "갖은등글월문: 등글월 문(攴)에 보탰다는 것." },
  
      { key: "4획-20", form: ["⽏"], sound: ["말 무"], define: "말: 하지 말라는 뜻." },
  
      { key: "4획-21", form: ["⽐"], sound: ["견줄 비"] },
  
      { key: "4획-22", form: ["⽑"], sound: ["터럭 모"] },
  
      { key: "4획-23", form: ["⽒"], sound: ["각시 씨", "성 씨"], define: "각시: 새색시" },
  
      { key: "4획-24", form: ["⽓"], sound: ["기운 기"] },
  
      { key: "4획-25", form: ["⽔", "氵", "氺"], sound: ["물 수", "삼수변", "아래물수"] },
  
      { key: "4획-26", form: ["⽕", "灬"], sound: ["불 화", "불화발"] },
  
      { key: "4획-27", form: ["⽖", "爫"], sound: ["손톱 조", "손톱머리"] },
  
      { key: "4획-28", form: ["⽗"], sound: ["아비 부"] },
  
      { key: "4획-29", form: ["⽘"], sound: ["효 효", "점괘 효"] },
  
      { key: "4획-30", form: ["⽙"], sound: ["나무조각 장", "장수장변"], define: "장수장변: 장수 장(將)에서 딴 변." },
  
      { key: "4획-31", form: ["⽚"], sound: ["조각 편"] },
  
      { key: "4획-32", form: ["⽛"], sound: ["어금니 아"] },
  
      { key: "4획-33", form: ["⽜", "牜"], sound: ["소 우", "소우변"] },
  
      { key: "4획-34", form: ["⽝", "犭"], sound: ["개 견", "개사슴록변"] },
    ],
    "5획": [
      { key: "5획-1", form: ["⽞"], sound: ["검을 현"] },
  
      { key: "5획-2", form: ["⽟", "⺩"], sound: ["구슬 옥", "구슬옥변"] },
  
      { key: "5획-3", form: ["⽠"], sound: ["오이 과"] },
  
      { key: "5획-4", form: ["⽡"], sound: ["기와 와"] },
  
      { key: "5획-5", form: ["⽢"], sound: ["달 감"] },
  
      { key: "5획-6", form: ["⽣"], sound: ["날 생"] },
  
      { key: "5획-7", form: ["⽤"], sound: ["쓸 용"] },
  
      { key: "5획-8", form: ["⽥"], sound: ["밭 전"] },
  
      { key: "5획-9", form: ["⽦", "⺪"], sound: ["발 소", "짝 필"], define: "짝: 짐승을 헤아릴 때 쓰는 단위." },
  
      { key: "5획-10", form: ["⽧"], sound: ["병들어기댈 녁", "병질엄"], define: "병질엄: 병 질(疾)에서 딴 엄호." },
  
      { key: "5획-11", form: ["⽨"], sound: ["걸을 발", "필발머리"], define: "필발머리: 필 발(發)의 머리." },
  
      { key: "5획-12", form: ["⽩"], sound: ["흰 백"] },
  
      { key: "5획-13", form: ["⽪"], sound: ["가죽 피"] },
  
      { key: "5획-14", form: ["⽫"], sound: ["그릇 명"] },
  
      { key: "5획-15", form: ["⽬"], sound: ["눈 목"] },
  
      { key: "5획-16", form: ["⽭"], sound: ["창 모"] },
  
      { key: "5획-17", form: ["⽮"], sound: ["화살 시"] },
  
      { key: "5획-18", form: ["⽯"], sound: ["돌 석"] },
  
      { key: "5획-19", form: ["⽰", "礻"], sound: ["보일 시", "제기"] },
  
      { key: "5획-20", form: ["⽱"], sound: ["짐승발자국 유"] },
  
      { key: "5획-21", form: ["⽲"], sound: ["벼 화"] },
  
      { key: "5획-22", form: ["⽳"], sound: ["구멍 혈", "굴 혈"] },
  
      { key: "5획-23", form: ["⽴"], sound: ["설 립"] },
    ],
    "6획": [
      { key: "6획-1", form: ["⽵", "⺮"], sound: ["대 죽"] },
  
      { key: "6획-2", form: ["⽶"], sound: ["쌀 미"] },
  
      { key: "6획-3", form: ["⽷"], sound: ["실 사", "가는실 멱"] },
  
      { key: "6획-4", form: ["⽸"], sound: ["장군 부"], define: "장군: 통은 크고 목이 좁은 옛날 거름을 담아 나르던 그릇." },
  
      { key: "6획-5", form: ["⽹", "罒", "䍏"], sound: ["그물 망"] },
  
      { key: "6획-6", form: ["⽺"], sound: ["양 양 "] },
  
      { key: "6획-7", form: ["⽻"], sound: ["깃 우"] },
  
      { key: "6획-8", form: ["⽼"], sound: ["늙을 로"] },
  
      { key: "6획-9", form: ["⽽"], sound: ["말이을 이"] },
  
      { key: "6획-10", form: ["⽾"], sound: ["쟁기 뢰"] },
  
      { key: "6획-11", form: ["⽿"], sound: ["귀 이"] },
  
      { key: "6획-12", form: ["⾀"], sound: ["붓 율"] },
  
      { key: "6획-13", form: ["⾁", "⽉"], sound: ["고기 육", "육달월"] },
  
      { key: "6획-14", form: ["⾂"], sound: ["신하 신"] },
  
      { key: "6획-15", form: ["⾃"], sound: ["스스로 자"] },
  
      { key: "6획-16", form: ["⾄"], sound: ["이를 지"] },
  
      { key: "6획-17", form: ["臼"], sound: ["절구 구"] },
  
      { key: "6획-18", form: ["⾆"], sound: ["혀 설"] },
  
      { key: "6획-19", form: ["⾇"], sound: ["어그러질 천"] },
  
      { key: "6획-20", form: ["⾈"], sound: ["배 주"] },
  
      { key: "6획-21", form: ["⾉"], sound: ["어긋날 간", "그칠 간"] },
  
      { key: "6획-22", form: ["⾊"], sound: ["빛 색"] },
  
      { key: "6획-23", form: ["⾋", "艹"], sound: ["풀 초", "초두머리"] },
  
      { key: "6획-24", form: ["⾌"], sound: ["호파무늬 호", "범호엄"] },
  
      { key: "6획-25", form: ["⾍"], sound: ["벌레 충", "벌레 훼", "살무사"] },
  
      { key: "6획-26", form: ["⾎"], sound: ["피 혈"] },
  
      { key: "6획-27", form: ["⾏"], sound: ["갈 행"] },
  
      { key: "6획-28", form: ["⾐", "衤"], sound: ["옷 의", "옷의변"] },
  
      { key: "6획-29", form: ["襾", "覀"], sound: ["덮을 아"] },
    ],
    "7획": [
      { key: "7획-1", form: ["⾒"], sound: ["볼 견"] },
  
      { key: "7획-2", form: ["⾓"], sound: ["뿔 각"] },
  
      { key: "7획-3", form: ["⾔"], sound: ["말씀 언"] },
  
      { key: "7획-4", form: ["⾕"], sound: ["골 곡"] },
  
      { key: "7획-5", form: ["⾖"], sound: ["콩 두", "제기이름"] },
  
      { key: "7획-6", form: ["⾗"], sound: ["돼지 시"] },
  
      { key: "7획-7", form: ["⾘"], sound: ["빌없는벌레 치", "해태 치", "갖은돼지 시"], define: "갖은돼지 시: 돼지 시(⾗)에 더욱 갖춘 것을 말함." },
  
      { key: "7획-8", form: ["⾙"], sound: ["조개 패"] },
  
      { key: "7획-9", form: ["⾚"], sound: ["붉을 적"] },
  
      { key: "7획-10", form: ["⾛"], sound: ["달릴 주"] },
  
      { key: "7획-11", form: ["⾜"], sound: ["발 족"] },
  
      { key: "7획-12", form: ["⾝"], sound: ["몸 신"] },
  
      { key: "7획-13", form: ["⾞"], sound: ["수레 거", "수레 차"] },
  
      { key: "7획-14", form: ["⾟"], sound: ["매울 신"] },
  
      { key: "7획-15", form: ["⾠"], sound: ["별 진", "별 신"] },
  
      { key: "7획-16", form: ["⾡", "辶"], sound: ["쉬엄쉬엄갈 착", "책받침"], define: "책받침: 변과 받침을 겸한 모양." },
  
      { key: "7획-17", form: ["⾢", "⻏"], sound: ["고을 읍", "우부방"] },
  
      { key: "7획-18", form: ["⾣"], sound: ["술 유", "닭 유"] },
  
      { key: "7획-19", form: ["⾤"], sound: ["분별할 변"] },
  
      { key: "7획-20", form: ["⾥"], sound: ["마을 리"] },
    ],
    "8획": [
      { key: "8획-1", form: ["⾦"], sound: ["쇠 금"] },
  
      { key: "8획-2", form: ["⾧"], sound: ["길 장"] },
  
      { key: "8획-3", form: ["⾨"], sound: ["문 문"] },
  
      { key: "8획-4", form: ["⾩", "阝"], sound: ["언덕 부", "좌부방변"] },
  
      { key: "8획-5", form: ["⾪"], sound: ["미칠 이"] },
  
      { key: "8획-6", form: ["⾫"], sound: ["새 추"] },
  
      { key: "8획-7", form: ["⾬"], sound: ["비 우"] },
  
      { key: "8획-8", form: ["⾭"], sound: ["푸를 청"] },
  
      { key: "8획-9", form: ["⾮"], sound: ["아닐 비"] },
    ],
    "9획": [
      { key: "9획-1", form: ["⾯"], sound: ["낯 면"] },
  
      { key: "9획-2", form: ["⾰"], sound: ["가죽 혁"] },
  
      { key: "9획-3", form: ["⾱"], sound: ["다룸가죽 위", "무두질한", "가죽 위"] },
  
      { key: "9획-4", form: ["⾲"], sound: ["부추 구"] },
  
      { key: "9획-5", form: ["⾳"], sound: ["소리 음"] },
  
      { key: "9획-6", form: ["⾴"], sound: ["머리 혈"] },
  
      { key: "9획-7", form: ["⾵"], sound: ["바람 풍"] },
  
      { key: "9획-8", form: ["⾶"], sound: ["날 비"] },
  
      { key: "9획-9", form: ["⾷", "⻞", "⻟"], sound: ["밥 식", "밥식변"] },
  
      { key: "9획-10", form: ["⾸"], sound: ["머리 수"] },
  
      { key: "9획-11", form: ["⾹"], sound: ["향기 향"] },
    ],
    "10획": [
      { key: "10획-1", form: ["⾺"], sound: ["말 마"] },
  
      { key: "10획-2", form: ["⾻"], sound: ["뼈 골"] },
  
      { key: "10획-3", form: ["⾼"], sound: ["높을 고"] },
  
      { key: "10획-4", form: ["⾽"], sound: ["터럭발", "긴털드리울 표"] },
  
      { key: "10획-5", form: ["⾾"], sound: ["싸울 투"], define: "鬪에서 가져온 것." },
  
      { key: "10획-6", form: ["⾿"], sound: ["울창주 창"], define: "울창주(鬱鬯酒): 제사를 위하여 특별히 담가놓은 술." },
  
      { key: "10획-7", form: ["⿀"], sound: ["다리굽은솥 력"] },
  
      { key: "10획-8", form: ["⿁"], sound: ["귀신 귀"] },
    ],
    "11획": [
      { key: "11획-1", form: ["⿂"], sound: ["물고기 어"] },
  
      { key: "11획-2", form: ["⿃"], sound: ["새 조"] },
  
      { key: "11획-3", form: ["⿄"], sound: ["소금밭 로"] },
  
      { key: "11획-4", form: ["⿅"], sound: ["사름 록"] },
  
      { key: "11획-5", form: ["⿆"], sound: ["보리 맥"] },
  
      { key: "11획-6", form: ["⿇"], sound: ["삼 마"] },
    ],
    "12획": [
      { key: "12획-1", form: ["⿈"], sound: ["누를 황"] },
  
      { key: "12획-2", form: ["⿉"], sound: ["기장 서"] },
  
      { key: "12획-3", form: ["⿊"], sound: ["검을 흑"] },
  
      { key: "12획-4", form: ["⿋"], sound: ["바느질 치"] },
    ],
    "13획": [
      { key: "13획-1", form: ["⿌"], sound: ["맹꽁이 맹"] },
  
      { key: "13획-2", form: ["⿍"], sound: ["솥 정"] },
  
      { key: "13획-3", form: ["⿎"], sound: ["북 고"] },
  
      { key: "13획-4", form: ["鼠"], sound: ["쥐 서"] },
    ],
    "14획": [
      { key: "14획-1", form: ["鼻"], sound: ["코 비"] },
  
      { key: "14획-2", form: ["⿑"], sound: ["가지런할 제"] },
    ],
    "15획": [{ key: "15획-1", form: ["⿒"], sound: ["이 치"] }],
    "16획": [
      { key: "16획-1", form: ["⿓"], sound: ["용 룡"] },
  
      { key: "16획-2", form: ["龜"], sound: ["거북 귀"] },
    ],
    "17획": [{ key: "17획-1", form: ["龠"], sound: ["피리 약"] }],
  }
}